/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import type { TViewError } from './models';

export const ViewError = ({
    Aligner,
    ButtonV2,
    Grid,
    ImgV2,
    TextHolder,
    TextV2,
    buttonText,
    className,
    description,
    img,
    onClick,
    title,
}: TViewError) => (
    <Aligner className={className}>
        <ImgV2 {...img} />
        <TextV2 styler={{ marginTop: 32, marginBottom: 0 }} tag="h2" view="medium">
            <TextHolder text={title} />
        </TextV2>
        <TextV2 styler={{ marginTop: 8, marginBottom: 32 }} view="primary-medium">
            <TextHolder text={description} />
        </TextV2>

        <Grid collapse columnsWidth={[267]}>
            <ButtonV2
                block
                data-test-id="backToBeginning"
                onClick={onClick}
                size="s"
                view="primary"
            >
                <TextHolder text={buttonText} />
            </ButtonV2>
        </Grid>
    </Aligner>
);
